<div class="privacy">
    <p style="line-height: 1.9em;" [innerHtml]="privacyTerms">
    </p>
</div>
